module.exports = __webpack_public_path__ + "img/Rider.4b89713b.svg";